import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, MapLocKeys } from '@cm/core/localization';

const dpRoot = 'Candidate|Eligibilities|';
const sharedProperties: Pick<LocDef, 'feature' | 'portal'> = {
	feature: HubFeature.ExamAuthorization,
	portal: 'SP',	
};

type LocNameStart = 'SPEligibilityEditDialog';
export type SPEligibilityEditDialogLocNames =
	| `${LocNameStart}FieldLabelAuthorizationId`
	| `${LocNameStart}FieldLabelActiveDate`
	| `${LocNameStart}FieldLabelExpireDate`
	| `${LocNameStart}FieldErrorActiveDateRequired`
	| `${LocNameStart}FieldErrorActiveDateInvalid`
	| `${LocNameStart}FieldErrorExpireDateInvalid`
	| `${LocNameStart}ButtonEditCancel`
	| `${LocNameStart}ButtonEditConfirm`;

export const spEligibilityEditDialogLocs: LocDefs<SPEligibilityEditDialogLocNames> = {
	SPEligibilityEditDialogFieldLabelAuthorizationId: {
		defaultValue: 'Eligibility Number',
		description: 'Label for the authorization ID field',
		displayPath: `${dpRoot}Field Label Authorization ID`,
		displayType: 'Label',  
        htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldLabel.AuthorizationId',
		...sharedProperties,
	},
	SPEligibilityEditDialogFieldLabelActiveDate: {
		defaultValue: 'Active Date',
		description: 'Label for the active date field',
		displayPath: `${dpRoot}Field Label Active Date`,
		displayType: 'Label',
        htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldLabel.ActiveDate',
		...sharedProperties,
	},
	SPEligibilityEditDialogFieldLabelExpireDate: {
		defaultValue: 'Expiration Date',
		description: 'Label for the expiration date field',
		displayPath: `${dpRoot}Field Label Expire Date`,
		displayType: 'Label',
        htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldLabel.ExpireDate',
		...sharedProperties,
	},
	SPEligibilityEditDialogFieldErrorActiveDateRequired: {
		defaultValue: 'The active date is required',
		description: 'Error message when active date is required',
		displayPath: `${dpRoot}Field Error Active Date Required`,
		displayType: 'Error',
        htmlAllowed: false,
		shared: true,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldError.ActiveDateRequired',
		...sharedProperties,
	},
	SPEligibilityEditDialogFieldErrorActiveDateInvalid: {
		defaultValue: 'The active date must be before the expiration date',
		description: 'Error message when active date is invalid',
		displayPath: `${dpRoot}Field Error Active Date Invalid`,
		displayType: 'Error',
        htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldError.ActiveDateInvalid',
		...sharedProperties,
	},
	SPEligibilityEditDialogFieldErrorExpireDateInvalid: {
		defaultValue: "Expiration date must be after the active date and today's date",
		description: 'Error message when expiration date is invalid',
		displayPath: `${dpRoot}Field Error Expire Date Invalid`,
		displayType: 'Error',
        htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.FieldError.ExpireDateInvalid',
		...sharedProperties,
	},
	SPEligibilityEditDialogButtonEditCancel: {
		defaultValue: 'Cancel',
		description: 'Button text for canceling the edit',
		displayPath: `${dpRoot}Button Edit Cancel`,
		displayType: 'Button',
        htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Button.EditCancel',
		...sharedProperties,
	},
	SPEligibilityEditDialogButtonEditConfirm: {
		defaultValue: 'Update',
		description: 'Button text for confirming the edit',
		displayPath: `${dpRoot}Button Edit Confirm`,
		displayType: 'Button',
        htmlAllowed: false,
		legacyName: 'Exam.Authorization/Candidates.Eligibilities.Button.EditConfirm',
		...sharedProperties,
	},
};

export const LOC_KEYS = MapLocKeys<SPEligibilityEditDialogLocNames>(spEligibilityEditDialogLocs);
